// This module should not have any dependencies on mojito
// Please try to keep it pure, without any unnecessary imports
import {isEmpty} from '#core/utils/config-utils.js';

export const getDetectedHostURL = () => {
    return window.location.protocol + '//' + window.location.host;
};

export const convertToHttpsProtocol = url => {
    return url.replace('http://', 'https://');
};

export const addParamToURL = (url, name, value) => {
    if (isEmpty(value)) {
        return url;
    }
    url = new URL(url, window.location.origin); // second argument (base) is used only when ${url} is a relative URL, otherwise it will be ignored.
    url.searchParams.set(name, value);

    return url.toString();
};

export const removeParamFromURL = (url, name) => {
    url = new URL(url);
    url.searchParams.delete(name);

    return url.toString();
};

export const removeAllParamsFromURL = url => {
    let parts = url.split('?');
    url = new URL(parts[0], window.location.origin);

    return url.toString();
};

/**
 *
 * @param paramName - Parameter name
 * @param url - Full url
 * @return {string|object} Value of param specified by paramName. Null if param not found
 */
export const getParamFromURL = (paramName, url = window.location.href) => {
    url = new URL(url);
    let parameter = url.searchParams.get(paramName);

    return parameter;
};

export const getAllParamsFromURL = (url = window.location.href) => {
    url = new URL(url);

    return Object.fromEntries(url.searchParams);
};

export const isCrawlerBot = () => {
    const robots = new RegExp(
        'googlebot|prerender|bingbot|yandex|baiduspider|twitterbot|facebookexternalhit|rogerbot' +
            '|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest/0.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp',
        'i'
    );

    return robots.test(navigator.userAgent);
};

/**
 * Make sure url is starting with slash
 * @param url {string}
 * @return {string}
 */
export const ensureStartingSlash = url => {
    if (url === null || url === undefined || url[0] === '/') {
        return url;
    }

    return '/' + url;
};

/**
 * Make sure url is NOT starting with slash
 * @param url {string}
 * @return {string}
 */
export const removeStartingSlash = url => {
    if (!url || url.length === 0) {
        return url;
    }
    if (url[0] === '/') {
        url = url.substring(1);
    }

    return url;
};

export const currentScriptSrc = new URL(document.currentScript.src);
export const currentScriptParams = currentScriptSrc.searchParams;
export const currentScriptOrigin = currentScriptSrc.origin;

export let internalResourcesLocation = undefined;

export const setInternalResourcesPath = url => {
    try {
        internalResourcesLocation = new URL(url, currentScriptOrigin).toString();
        internalResourcesLocation = ensureTrailingSlash(internalResourcesLocation);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to set internal resources location', e);
    }
};

export const absoluteUrlToInternalResource = url => {
    if (url.startsWith('/')) {
        url = url.substring(1);
    }

    const result = new URL(url, internalResourcesLocation || currentScriptOrigin);
    result.searchParams.set('v', GIT_HASH); // add version param to prevent caching

    return result.toString();
};

/**
 * @param prefix {string}
 * @param url {string}
 * @return {string} Url starting with the '/' character
 */
export const stripRoutingPrefix = (prefix, url) => {
    if (prefix === '/') return url;

    url = ensureStartingSlash(url);
    if (url?.startsWith(prefix)) {
        return url.substring(prefix.length);
    } else {
        return url;
    }
};

/**
 * Remove pathLang from routing prefix
 * @param prefix {string}
 * @return {string}
 */
export const stripPathLang = prefix => {
    const found = prefix.match(/.*\/([^/]+)$/);

    if (found) {
        return `/${found[1]}`;
    } else {
        return '/';
    }
};

/**
 * Removes trailing slashes from the end of a URL string.
 *
 * @param {string} url - The URL to process.
 * @returns {string} The URL without any trailing slashes.
 *
 * @example
 * trimTrailingSlash('https://example.com/'); // 'https://example.com'
 * trimTrailingSlash('https://example.com/test/abcd/'); // 'https://example.com/test/abcd'
 */
export const trimTrailingSlash = url => {
    return url.replace(/\/+$/, '');
};

/**
 * Make sure url is ending with slash
 *
 * @param {string} url - The URL to process.
 * @returns {string} The URL with trailing slashes.
 *
 */
export const ensureTrailingSlash = url => {
    if (!url) return url;
    if (url[url.length - 1] !== '/') {
        url += '/';
    }

    return url;
};

export const getDeeplink = ({path, betRefs = [], append = {}, exclude = []}) => {
    const url = new URL(path, window.location.origin);

    if (betRefs.length > 0) {
        const queryParams = [
            ...betRefs.map(betRef => ['bet_ref', betRef]),
            ...Object.entries(append).filter(([, value]) => value !== undefined),
        ];

        queryParams.forEach(([key, value]) => url.searchParams.append(key, value));
    }

    exclude.forEach(key => url.searchParams.delete(key));

    return url.toString();
};
